/* eslint-disable */
export default {
	NODE_ENV: 'production',
	API_URL: 'https://distribution.lr-lab.com/api',
	AUTH_URL: 'https://distribution.lr-lab.com/api/auth/login',
	LR_CLOUD_URL: 'http://cloud.lr-lab.com'
}
/* eslint-enable */
